import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useTenantTranslation } from "hooks/formatters";
import { useTenant } from "hooks/settings";
import { useProvisionNewManualDeviceMutation } from "src/store/api/generatedApi";
import { useNotifyStatus } from "contexts/status";
import { LoadingButton } from "@mui/lab";
import AddIcon from "@mui/icons-material/Add";

export const ProvisionManualDeviceButton = () => {
  const { t } = useTenantTranslation();
  const [open, setOpen] = useState(false);
  const [deviceName, setDeviceName] = useState("");
  const tenantName = useTenant();
  const notifyStatus = useNotifyStatus();

  const [provisionDevice, { isLoading }] =
    useProvisionNewManualDeviceMutation();

  const handleOpen = () => {
    setOpen(true);
    setDeviceName("");
  };

  const handleClose = () => {
    setOpen(false);
    setDeviceName("");
  };

  const handleProvision = async () => {
    if (!deviceName.trim()) {
      notifyStatus({ type: "error", text: t("deviceNameRequired") });
      return;
    }

    try {
      const result = await provisionDevice({
        tenantName,
        name: deviceName.trim(),
      }).unwrap();

      setOpen(false);
      notifyStatus({
        type: "success",
        text: t("deviceProvisionedSuccessfully", { deviceName: result.name }),
      });
    } catch (error) {
      console.error("Failed to provision device:", error);
      notifyStatus({
        type: "error",
        text: t("deviceProvisioningFailed"),
      });
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={handleOpen}
        sx={{ whiteSpace: "nowrap" }}
      >
        {t("provisionManualDevice")}
      </Button>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>{t("provisionManualDevice")}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label={t("deviceName")}
            type="text"
            fullWidth
            variant="outlined"
            value={deviceName}
            onChange={(e) => {
              setDeviceName(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && deviceName.trim()) {
                void handleProvision();
              }
            }}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={isLoading}>
            {t("cancel")}
          </Button>
          <LoadingButton
            onClick={() => void handleProvision()}
            loading={isLoading}
            variant="contained"
            disabled={!deviceName.trim()}
          >
            {t("provisionDevice")}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
